import {
  queryAddEditSetFormFieldValue,
  queryAddNewSetFormFieldValue,
  queryDeleteItem,
  queryEditItemSetFormFieldValue,
  queryList,
} from './service';

import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'setFormFieldValue',
  state: {
    newSetFormFieldValue: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: meta,
    select: 'id,valueSource,fixedValue,formula,internalField',
    expand: {
      form: { select: 'name' },
      field: { select: 'displayText' },
      sourceForm: { select: 'name' },
      sourceField: { select: 'displayText' },
      sourceVariable: { select: 'internalName' },
    },
    paramsView: {
      select: 'id,id,valueSource,fixedValue,formula,internalField,created,updated',
      expand: {
        form: { select: 'name' },
        field: { select: 'displayText' },
        sourceForm: { select: 'name' },
        sourceField: { select: 'displayText' },
        sourceVariable: { select: 'internalName' },
      },
    },
    view: false,
    orderBy: '',
    id: null,
    loadingItem: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(queryList, payload);
        yield put({
          type: 'querySetFormFieldValues',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewSetFormFieldValue({ payload }, { put }) {
      yield put({
        type: 'addSetFormFieldValue',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewSetFormFieldValue',
          payload,
        });
      }
    },

    *editItemSetFormFieldValue({ payload }, { call, put }) {
      try {
        const table = yield call(queryEditItemSetFormFieldValue, payload);
        yield put({
          type: 'editSetFormFieldValue',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *saveNewSetFormFieldValue({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddNewSetFormFieldValue, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveSetFormFieldValue',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          if (error.validationErrors && _.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *saveEditSetFormFieldValue({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddEditSetFormFieldValue, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveSetFormFieldValue',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(queryDeleteItem, id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveSetFormFieldValue',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *showItemSetFormFieldValue({ view }, { put }) {
      yield put({
        type: 'showEditItemSetFormFieldValue',
        view,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    querySetFormFieldValues(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addSetFormFieldValue(state, { payload }) {
      return {
        ...state,
        newSetFormFieldValue: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewSetFormFieldValue(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editSetFormFieldValue(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },

    saveSetFormFieldValue(state, { payload }) {
      return {
        ...state,
        saveSetFormFieldValue: payload,
        newSetFormFieldValue: false,
        selectedItem: false,
      };
    },

    showEditItemSetFormFieldValue(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newSetFormFieldValue: false,
        selectedItem: null,
        view: null,
        orderBy: '',
        id: null,
      };
    },
  },
};

export default Model;
